"use client";

import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";
import { createContext, useContext, useMemo, useState } from "react";

type RPCContextType = {
  endpoint: string;
  setEndpoint: (url: string) => void;
};

const RPCContext = createContext<RPCContextType>({
  endpoint: clusterApiUrl(WalletAdapterNetwork.Devnet),
  setEndpoint: () => {},
});

export const useRPC = () => {
  const context = useContext(RPCContext);
  if (!context) {
    throw new Error("useRPC must be used within a RPCProvider");
  }
  return context;
};

export function SolanaProvider({ children }: { children: React.ReactNode }) {
  const network = WalletAdapterNetwork.Devnet;
  const [endpoint, setEndpoint] = useState(clusterApiUrl(network));
  const wallets = useMemo(() => [new PhantomWalletAdapter()], []);

  return (
    <RPCContext.Provider value={{ endpoint, setEndpoint }}>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect>
          <WalletModalProvider>{children}</WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
    </RPCContext.Provider>
  );
}
